var map = {
	"@auth/login/login.module": [
		"./src/app/auth/login/login.module.ts",
		"auth-login-login-module"
	],
	"@auth/register/register.module": [
		"./src/app/auth/register/register.module.ts",
		"auth-register-register-module"
	],
	"@home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"@spotlight/spotlight.module": [
		"./src/app/spotlight/spotlight.module.ts",
		"spotlight-spotlight-module"
	],
	"@support/support.module": [
		"./src/app/support/support.module.ts",
		"support-support-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;